/**
 * Service pour les patients
 */

import { apiClient } from './apiClient';
import { API_ENDPOINTS } from '@/config/api';
import { Patient, PatientCreate } from '@/shared/types/patient';

export interface PatientListParams {
  service?: string;
  search?: string;
  page?: number;
  size?: number;
}

export interface PatientListResponse {
  items: Patient[];
  total: number;
  page: number;
  size: number;
  pages: number;
}

export const patientService = {
  async list(params: PatientListParams = {}): Promise<PatientListResponse> {
    const queryParams = new URLSearchParams();
    if (params.service) queryParams.append('service', params.service);
    if (params.search) queryParams.append('search', params.search);
    if (params.page) queryParams.append('page', params.page.toString());
    if (params.size) queryParams.append('size', params.size.toString());

    const url = `${API_ENDPOINTS.patients}?${queryParams.toString()}`;
    return apiClient.get<PatientListResponse>(url);
  },

  async getById(id: string): Promise<Patient> {
    return apiClient.get<Patient>(API_ENDPOINTS.patient(id));
  },

  async create(data: PatientCreate): Promise<Patient> {
    return apiClient.post<Patient>(API_ENDPOINTS.patients, data);
  },

  async update(id: string, data: Partial<PatientCreate>): Promise<Patient> {
    return apiClient.patch<Patient>(API_ENDPOINTS.patient(id), data);
  },

  async delete(id: string): Promise<void> {
    return apiClient.delete<void>(API_ENDPOINTS.patient(id));
  },
};
